










import { Component, Mixins } from "vue-property-decorator";

@Component({
})
export default class ComboBoxMenuObject extends Mixins() {
  onMousewheel(e: WheelEvent): void {
    // IEでは@scroll.stop.preventで伝播を止められないのでホイールイベントを監視して伝播を止めている（スクロール端でscrollイベント発生しない？）
    const combo = this.$refs.combo as HTMLDivElement;
    if (e.deltaY > 0) {
      // 下方向にスクロールしようとしている
      if (combo.scrollTop + combo.clientHeight >= combo.scrollHeight) {
        e.stopPropagation();
        e.preventDefault();
      }
    } else {
      // 上方向にスクロールしようとしている
      if (combo.scrollTop === 0) {
        e.stopPropagation();
        e.preventDefault();
      }
    }
  }
}
